import React, { useMemo } from 'react';
import { Header } from 'semantic';
import { useTranslation } from 'react-i18next';
import { CustomerGroup } from 'subdomains/cpo/types/charging-policy';
import ThemedSegment from 'components/semantic/Segment';

type Props = {
  values: CustomerGroup;
};

export const CustomerGroupPreview: React.FC<Props> = ({ values }) => {
  const { t } = useTranslation();

  const filterString = useMemo(() => {
    return values.filters
      .reduce<string[]>((stringComponents, filter) => {
        const count = filter.values?.length || 0;
        if (count === 0) return stringComponents;

        const translationKey = `providerAdmin.customerGroupPreview.filterCount${filter.type.toLowerCase()}`;
        const defaultText = {
          ACCOUNT: '{{count}} Accounts',
          USER: '{{count}} Users',
          CONSUMER_CARD_BILLING_PLAN: '{{count}} Card Billing Plans',
          INFRA_TOKEN_PROVIDER: '{{count}} Infra Token Providers',
          UID: '{{count}} Token IDs',
          ISSUER_NAME: '{{count}} Issuer Names',
        }[filter.type];

        stringComponents.push(t(translationKey, defaultText, { count }));
        return stringComponents;
      }, [])
      .join(', ');
  }, [values.filters, t]);

  return (
    <ThemedSegment offbackground>
      <Header as="h4" content={values.label} style={{ marginTop: 0 }} />
      <p>{filterString}</p>
    </ThemedSegment>
  );
};
